import type { HeroModuleOptions, NimbusModuleOptions } from '@nimbus/types'
import { useRuntimeConfig } from '#imports'

export const useHeroConfig = (): HeroModuleOptions => {
    const config = useRuntimeConfig()

    return (config.public.nimbus as NimbusModuleOptions).hero as HeroModuleOptions
}
